import PropTypes from 'prop-types';
import Immutable from 'immutable';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import green from '@mui/material/colors/green';
import red from '@mui/material/colors/red';
import {
  TableRow,
  TableCell,
  colors,
  Menu,
  MenuItem,
  ListItemText,
  Divider
} from '@mui/material';
import Button from 'app/common/button';

import shallowEqual from 'app/lib/shallow-equal';
import i18n from 'app/common/i18n';
import StatusChip from './StatusChip';
import { currencyString } from 'app/common/format';
import { date } from 'app/lib/format';

import { toggleActivation } from 'app/redux/modules/dwellings';
import { expiredListingType } from '../../utils/helpers';

@connect(() => ({}), { toggleActivation })
@i18n
class DwellingsListItem extends Component {
  static propTypes = {
    cellClassName: PropTypes.string,
    item: PropTypes.instanceOf(Immutable.Map).isRequired,
    admin: PropTypes.bool.isRequired,
    onDuplicate: PropTypes.func.isRequired,
    toggleActivation: PropTypes.func.isRequired,
    onAuditOpen: PropTypes.func.isRequired,
    onDeactivation: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !(
      shallowEqual(this.props, nextProps) && shallowEqual(this.state, nextState)
    );
  }

  handleDuplicate = () => {
    this.handleMenuClose();

    const { item } = this.props;
    const uuid = item.get('uuid');
    const address = (
      item.getIn(['location', 'address']) || this.props.i18n('(no address)')
    ).replace(/, [0-9]{4} [A-ZÆØÅ].*/, '');
    this.props.onDuplicate({ uuid, address });
  };

  toggleActivation = () => {
    this.handleMenuClose();

    const { item } = this.props;
    if (item.get('active')) {
      this.props.onDeactivation(item.toJS());
    }
    this.props.toggleActivation(item.get('uuid'), !item.get('active'));
  };

  showAudit = () => {
    this.handleMenuClose();
    this.props.onAuditOpen(this.props.item.get('uuid'));
  };

  handleMenuOpen = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleMenuClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { user, admin, item, cellClassName } = this.props;

    const uuid = item.get('uuid');
    const address = (
      <span>
        {(
          item.getIn(['location', 'address']) || this.props.i18n('(no address)')
        ).replace(/, [0-9]{4} [A-ZÆØÅ].*/, '')}
        <br />
        {item.getIn(['location', 'zip'])
          ? `${item.getIn(['location', 'zip'])} ${item.getIn([
              'location',
              'city'
            ])}`
          : ''}
      </span>
    );
    const rooms = item.getIn(['size', 'rooms']);
    const area = item.getIn(['size', 'area']);
    const listingType = item.get('listingType');

    const active = item.get('active');
    const locked = item.get('status') === 'APPROVED';

    const createdAt = new Date(item.get('createdAt'));

    const menuOpen = Boolean(this.state.anchorEl);

    return (
      <TableRow
        style={{
          background:
            item.get('status') === 'APPROVED'
              ? active
                ? green[50]
                : '#fff'
              : item.get('status') === 'REJECTED'
              ? red[50]
              : '#fff',
          opacity: active ? 1 : 0.5,
          textAlign: 'left'
        }}
      >
        <TableCell
          padding="normal"
          className={cellClassName}
          style={{
            textAlign: 'right',
            fontSize: '0.8em',
            padding: '1'
          }}
        >
          <Button
            label={this.props.i18n('Action')}
            aria-label="More"
            aria-owns={menuOpen ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleMenuOpen}
          />
          <Menu
            id="long-menu"
            anchorEl={this.state.anchorEl}
            open={menuOpen}
            onClose={this.handleMenuClose}
          >
            {/* //TODO: no need for the check? */}
            {/* {admin ||
            item.get('active') /* && item.get('status') !== 'APPROVED' ? (
              <MenuItem
                dense
                component={Link}
                to={`/dwellings/${uuid}`}
                key="edit"
                onClick={this.handleMenuClose}
              >
                <ListItemText primary={this.props.i18n('Edit')} />
              </MenuItem>
            ) : null} */}

            <MenuItem
              dense
              component={Link}
              to={`/dwellings/${uuid}`}
              key="edit"
              onClick={this.handleMenuClose}
            >
              <ListItemText primary={this.props.i18n('Edit')} />
            </MenuItem>

            <MenuItem
              dense
              component={Link}
              to={`/dwellings/${uuid}/preview`}
              key="review"
              onClick={this.handleMenuClose}
            >
              <ListItemText primary={this.props.i18n('Review')} />
            </MenuItem>
            <MenuItem dense key="activation" onClick={this.toggleActivation}>
              <ListItemText
                primary={
                  item.get('active')
                    ? this.props.i18n('Deactivate')
                    : this.props.i18n('Activate')
                }
              />
            </MenuItem>
            <MenuItem dense key="duplicate" onClick={this.handleDuplicate}>
              <ListItemText primary={this.props.i18n('Duplicate')} />
            </MenuItem>
            {admin ? <Divider /> : null}
            {admin ? (
              <MenuItem dense key="audit" onClick={this.showAudit}>
                <ListItemText
                  primary={this.props.i18n('Created')}
                  secondary={
                    !isNaN(createdAt.getTime()) ? date.format(createdAt) : null
                  }
                />
              </MenuItem>
            ) : null}
          </Menu>
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap' }}
        >
          {uuid && active ? (
            <Link
              to={locked ? `/dwellings/${uuid}/preview` : `/dwellings/${uuid}`}
            >
              {address}
            </Link>
          ) : (
            address
          )}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap', textAlign: 'left' }}
          align="right"
        >
          {currencyString(item.getIn(['economy', 'rent']))}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap' }}
        >
          {rooms ? this.props.i18n('%s rooms', rooms) : '-'} /{' '}
          {area ? this.props.i18n('%s m²', area) : '-'}
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{ whiteSpace: 'nowrap' }}
        >
          <StatusChip
            dwelling={{
              active: item.get('active'),
              status: item.get('status')
            }}
            user={user.toJS()}
          />
        </TableCell>
        <TableCell
          padding="none"
          className={cellClassName}
          style={{
            whiteSpace: 'nowrap'
          }}
        >
          {!expiredListingType(item.get('deactivatedAt')) ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '175px'
              }}
            >
              <div>{listingType ? listingType : '-'}</div>
              {listingType !== 'PREMIUM' ? (
                <Button
                  size="small"
                  fullWidth={false}
                  label="Opgradér"
                  style={{
                    backgroundColor: colors.green[500],
                    color: '#fff'
                  }}
                  to={`/dwellings/${uuid}/status`}
                />
              ) : null}
            </div>
          ) : (
            '-'
          )}
        </TableCell>
      </TableRow>
    );
  }
}

export default DwellingsListItem;
